import { InfoIcon } from 'lucide-react'

import { CopyTextButton } from '@/components/CopyTextButton'
import { cn } from '@/lib/utils'

interface Props {
  index: number
  isAddressLine2: boolean
  field: {
    label: string
    value: string
    helperText?: string
  }
}
export const WarehouseAddressPreview = ({ index, isAddressLine2, field }: Props) => {
  return (
    <div className={cn('', index === 0 ? 'pt-0' : '', isAddressLine2 ? 'bg-background-snackbar rounded-lg p-3' : '')}>
      <div className={cn('flex items-center justify-between')}>
        <div className='flex items-center gap-3'>
          <CopyTextButton value={field.value} tooltipText='הועתק!' />
        </div>
        <div className='flex flex-col items-end gap-1 text-end'>
          <p className='text-text-secondary text-sm leading-5'>{field.label}</p>
          <p dir='ltr' className='text-text-primary text-left text-sm leading-5 font-medium whitespace-pre-line'>
            {field.value}
          </p>
          {field.helperText && <p className='text-text-secondary mt-1 text-xs leading-4'>{field.helperText}</p>}
        </div>
      </div>
      {isAddressLine2 && (
        <div className='flex items-center gap-2'>
          <InfoIcon className='text-text-secondary text-xs' />
          <p className='text-text-secondary text-xs leading-4'>זהו קוד הזיהוי האישי שלך- חובה להכניס אותו כדי שנוכל לשייך אליך את החבילה</p>
        </div>
      )}
    </div>
  )
}
